import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {
  setFirstName,
  setLastName,
  setEmailAddress,
  setMobilePhone,
  setDateOfBirth,
  setGender,
  setMaritalStatus,

  setFirstNameErrors,
  setLastNameErrors,
  setEmailAddressErrors,
  setMobilePhoneErrors,
  setDateOfBirthErrors,
  setGenderErrors,
  setMaritalStatusErrors
} from '../../../actions/spouse';
import ContactForm from './ContactForm';


const SpouseForm = connect(
  (state) => {
    let {
      First_Name, Last_Name, Email_Address, Mobile_Phone,
      Date_of_Birth, Gender_ID, Marital_Status_ID
    } = state.spouse;

    return {
      First_Name: First_Name.value,
      First_Name_Errors: First_Name.errors,

      Last_Name: Last_Name.value,
      Last_Name_Errors: Last_Name.errors,

      Email_Address: Email_Address.value,
      Email_Address_Errors: Email_Address.errors,

      Mobile_Phone: Mobile_Phone.value,
      Mobile_Phone_Errors: Mobile_Phone.errors,

      Date_of_Birth: Date_of_Birth.value,
      Date_of_Birth_Errors: Date_of_Birth.errors,

      Gender_ID: Gender_ID.value,
      Gender_ID_Errors: Gender_ID.errors,

      hideMaritalStatus: true,
      hideDateOfBirth: true,
      hideGender: true,
      className: 'spouse-form',
      title: First_Name.value ? `${First_Name.value}'s Info` : 'Spouse Info'
    };
  },
  (dispatch) => ({
    setFirstName(value) {
      dispatch(setFirstName(value));
    },
    setFirstNameErrors(errors) {
      dispatch(setFirstNameErrors(errors));
    },

    setLastName(value) {
      dispatch(setLastName(value));
    },
    setLastNameErrors(value) {
      dispatch(setLastNameErrors(value));
    },

    setEmailAddress(value) {
      dispatch(setEmailAddress(value));
    },
    setEmailAddressErrors(value) {
      dispatch(setEmailAddressErrors(value));
    },

    setMobilePhone(value) {
      dispatch(setMobilePhone(value));
    },
    setMobilePhoneErrors(value) {
      dispatch(setMobilePhoneErrors(value));
    },

    setDateOfBirth(value) {
      dispatch(setDateOfBirth(value));
    },
    setDateOfBirthErrors(value) {
      dispatch(setDateOfBirthErrors(value));
    },

    setGender(value) {
      dispatch(setGender(value));
    },
    setGenderErrors(value) {
      dispatch(setGenderErrors(value));
    }
  })
)(ContactForm);


export default SpouseForm;


// WEBPACK FOOTER //
// ./src/components/form-route/forms/SpouseForm.js